var map = {
	"./coalicion centro esperanza.png": 8,
	"./col1.png": 2665,
	"./col4.png": 6638,
	"./equipo por colombia.png": 4585,
	"./logo-elecciones-colombia.png": 7262,
	"./logo-elecciones-mexico_horizontal.png": 7771,
	"./logo-elecciones-mexico_vertical.png": 2225,
	"./pacto historico.png": 5656
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4548;